import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { CashflowBankAccountsContextProvider } from './pages/components/CashflowBankAccountsContext';
import Overview from './pages/Overview';
import Treasury from './pages/Treasury';
import * as routes from './routes';

const Dashboard: FC = () => (
  // We use the context here to share the selected
  // bank account between pages
  // We can't put it under Switch because switch
  // swiches based on children
  <CashflowBankAccountsContextProvider>
    <Switch>
      <Route component={Overview} path={routes.overview} />
      <Route component={Treasury} path={routes.treasury} />

      <Route path="*">
        <Redirect to={routes.overview} />
      </Route>
    </Switch>
  </CashflowBankAccountsContextProvider>
);

export default Dashboard;
